import type { ReactElement } from 'react';
import { Tag, theme, type TagProps } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';
import { getEnumLabel, getTagGroup } from '../../shared/format/enum-labels.js';
import './tag-chip.css';

export function TagChip({
  value,
  ...props
}: { value: string } & Pick<TagProps, 'closable' | 'onClose' | 'onMouseDown'>): ReactElement {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const group = getTagGroup(value);
  const colors =
    group === 'temperature'
      ? value === 'cold'
        ? [token.colorInfoBg, token.colorInfoTextHover]
        : [token.colorWarningBg, token.colorWarningTextHover]
      : group === 'value'
        ? [token['gold-1'], token['gold-9']]
        : group === 'risk'
          ? [token.colorErrorBg, token.colorErrorTextHover]
          : [token.colorFillSecondary, token.colorTextSecondary];
  return (
    <Tag
      {...props}
      style={{
        background: colors[0],
        color: colors[1],
        border: 'none',
        margin: 0,
        fontSize: 11,
        lineHeight: '20px',
        fontFamily: 'inherit',
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
      }}
    >
      {getEnumLabel('tag', value, t)}
    </Tag>
  );
}
